<template>
  <div class="space-y-8">
    <div v-if="$isAdminOrSuperAdmin || canCreateTasks">
      <AddTaskAction :project-id="projectId" />
    </div>
    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <ul v-else-if="resolved" class="space-y-3">
      <template v-if="tasks.length">
        <li v-for="task in tasks" :key="task.uuid">
          <TaskLine :task="task" @edit="editTask" />
        </li>
      </template>
      <li v-else>
        <div class="bg-white shadow overflow-hidden rounded-md px-6 py-4 text-center">
          No tasks found.
        </div>
      </li>
    </ul>
    <div v-else-if="rejected" class="rounded-md bg-red-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <!-- Heroicon name: solid/x-circle -->
          <svg
            class="h-5 w-5 text-red-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414
              1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293
              1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0
              00-1.414-1.414L10 8.586 8.707 7.293z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <div class="ml-3">
          <h3 class="text-sm font-medium text-red-800">
            Something went wrong! Please try again and if problem persists then contact support.
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddTaskAction from '@/components/ProjectTasks/AddTaskAction.vue';
import TaskLine from 'Components/ProjectTasks/TaskLine.vue';

export default {
  components: {
    TaskLine,
    AddTaskAction,
  },
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    tasks() {
      return this.$store.getters['ui/projectTasks/tasksByProject'](this.projectId);
    },
    project() {
      return this.$store.state.entities.projects.byId[this.projectId] || null;
    },
    canCreateTasks() {
      return (
        this.$currentAccount.id === this.project?.accountUuid &&
        this.$membershipHasPermissionTo('create tasks')
      );
    },
  },
  created() {
    this.fetchProjectTasks();
  },
  methods: {
    setLoading(loading = true) {
      this.loading = Boolean(loading);
    },
    setResolved(resolved = true) {
      this.resolved = Boolean(resolved);
    },
    setRejected(rejected = true) {
      this.rejected = Boolean(rejected);
    },
    async fetchProjectTasks() {
      if (this.loading) {
        return;
      }

      this.setLoading();
      try {
        await this.$store.dispatch('ui/projectTasks/load', {
          projectId: this.projectId,
          params: {
            include: [
              'linksCount',
              'mediaCount',
              'notesCount',
              'userAssigned',
              'accountAssigned',
            ].join(','),
          },
        });

        this.setResolved();
      } catch (error) {
        this.setRejected();
      } finally {
        this.setLoading(false);
      }
    },
    editTask(taskId) {
      this.$modal.show({
        component: 'ProjectTaskModal',
        props: {
          taskId,
        },
        on: {},
        hideEvent: 'task-modal:closed',
      });
    },
  },
};
</script>
